import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { getComponentName } from '@wix/da-react-context/pkg/helpers';
export const SisuContext = /*#__PURE__*/ React.createContext(false);
SisuContext.displayName = 'SisuContext';
// HOC for convenience...
export function withSisuContext(Component) {
    const DecoratedComponent = (props)=>{
        const isSisu = useContext(SisuContext);
        return /*#__PURE__*/ React.createElement(Component, _extends({
            isSisu: isSisu
        }, props));
    };
    DecoratedComponent.displayName = `withSisuContext(${getComponentName(Component)})`;
    return DecoratedComponent;
}
